import React from 'react';
import { tfNSWCardTypes } from 'consts/transport';
import { useStoreSelector } from 'store';
import InputTemplate from '../InputTemplate/InputTemplate';

const InputFamilyName: React.FC = () => {
  const tfNSWCardType = useStoreSelector(
    (state) => state.tfNSWCustomer.tfNSWCardType
  );

  const firstName = useStoreSelector((state) => state.tfNSWCustomer.data.firstName);
  const lastName = useStoreSelector((state) => state.tfNSWCustomer.data.lastName);

  // Custom validation messages
   const requiredFamilyNameMessage = 'Enter your family name as it appears on the card.';
   const missingFamilyNameMessage = "If you have only one name, enter it in the Family Name field and leave Given Name field blank or enter a hyphen '-'";
 
   let errorMessage = '';
   if (!firstName && !lastName) {
     errorMessage = requiredFamilyNameMessage; // Both names are empty
   } else if (firstName && !lastName) {
     errorMessage = missingFamilyNameMessage; // First name exists but family name is missing
   }


  return (
    <InputTemplate
      dataKey='lastName'
      label='Family name'
      helpMessage={
        tfNSWCardType === tfNSWCardTypes.drivesLicenceNumber
          ? drlHelperMessage
          : ''
      }
      requiredErrorMessage={errorMessage}
      isSpaceAllowed={true}
      isRequired={true}
    />
  );
};

export default InputFamilyName;

const drlHelperMessage =
  'This is printed on the licence card in CAPITAL LETTERS.';
export const familyNameLabel = 'Family name';
